import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import App from './components/App.vue';
import Hotjar from 'vue-hotjar';

import heyuiConfig from './js/config/heyui-config';
import routerConfig from './js/config/router-config';
import store from './js/vuex/store';
import './js/vue/components';
import './js/vue/filters';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useGlobalMixin } from './js/global/globalMixin';

// https://github.com/phegman/v-show-slid
import VShowSlide from 'v-show-slide';

// https://vcalendar.io/
import VCalendar from 'v-calendar';

// https://github.com/shipshapecode/vue-shepherd
import tourShepherd from 'vue-shepherd';

// https://matteo-gabriele.gitbook.io/vue-gtag/
import VueGtag from 'vue-gtag';

import VueI18n from 'vue-i18n';
import en from 'heyui/dist/locale/en-US';
import ptbr from './locale/pt_BR';

if ((process.env.NODE_ENV === 'production')) {
  import('./registerServiceWorker');
}

require('./css/app.less');
heyuiConfig(); // variaveis globais do hey.conf
const router = routerConfig();

Vue.use(Hotjar, {
  id: process.env.VUE_APP_HOTJAR_ID,
  isProduction: process.env.NODE_ENV == 'production',
  snippetVersion: 6
});

Vue.use(VueGtag, {
  appName: 'Perfil Performance - f360',
  pageTrackerScreenviewEnabled: false,
  pageTrackerTemplate(to) {
    let user = JSON.parse(localStorage.getItem('v360.user')) || '';
    if (!user) {
      return {
        page_path: to.path,
        page_location: window.location.href
      };
    }

    let permissao = JSON.parse(localStorage.getItem('v360.permissao')) || null;
    const isAdmin = permissao
      ? permissao.find(p => p === 'ListarRegras')
      : false;

    let userInfos;
    if (user.accessToken) {
      userInfos = Utils.parseJwt(user.accessToken);
    }
    const marcas = (() => {
      if (user.marcas && user.marcas.length) {
        const marcasString = user.marcas.reduce((acc, m, i) => {
          acc = `${acc}${i ? ',' : ''}${m.description}`;
          return acc;
        }, '');
        return marcasString;
      }
      return '';
    })();
    const qtdEMpresas = (() => {
      if (!userInfos) return 0;
      const qtd = userInfos['user.empresa'];
      if (qtd && qtd.length) {
        return qtd.split(',').length;
      }
      return 0;
    })();

    const dimensoes = {
      'usuario_nome': user.nome || '',
      'usuario_email': user.email || '',
      'usuario_id': userInfos['user.id'] || '',
      'grupo_nome': user.cliente || '',
      'grupo_codigo': '',
      'grupo_id': userInfos['user.cliente'] || '',
      'grupo_tipo_perfil': isAdmin ? 'Administrador' : 'Usuário comum',
      'grupo_marcas': marcas,
      'grupo_qtd_empresas': qtdEMpresas,
      'usuario_adm': !!isAdmin
    };

    let { name, path } = to;
    const isRootPath = path === '/' && name;
    return {
      page_path: isRootPath ? `${path + name}` : to.path,
      page_location: window.location.href,
      ...dimensoes
    };
  },
  config: {
    id: process.env.NODE_ENV === 'development'
      ? 'UA-66191766-12'
      : 'UA-66191766-13',
    params: {
      custom_map: {
        dimension1: 'usuario_nome',
        dimension2: 'usuario_email',
        dimension3: 'usuario_id',
        dimension4: 'grupo_nome',
        dimension5: 'grupo_codigo',
        dimension6: 'grupo_id',
        dimension7: 'grupo_tipo_perfil',
        dimension8: 'grupo_marcas',
        dimension9: 'grupo_qtd_empresas',
        dimension10: 'usuario_adm'
      }
    }
  }
}, router);

useGlobalMixin(Vue);

Vue.use(VueI18n);
Vue.use(VShowSlide);
Vue.use(tourShepherd);
Vue.use(VCalendar, {
  componentPrefix: 'vc',
  locales: {
    'pt-BR': {
      firstDayOfWeek: 1,
      masks: {
        L: 'YYYY-MM-DD'
      }
    },
    screens: {
      'sm': '640px', // (min-width: 640px)
      'md': '768px', // (min-width: 768px)
      'lg': '1024px', // (min-width: 1024px)
      'xl': '1280px' // (min-width: 1280px)
    }
  }// Use <vc-calendar /> instead of <v-calendar />
});

const messages = {
  en: Object.assign({ message: 'hello' }, en),
  pt_BR: Object.assign({ message: 'Olá' }, ptbr)
};

const i18n = new VueI18n({
  locale: 'Pt-BR', // set locale
  fallbackLocale: 'en',
  messages
});

export const eventBus = new Vue();

// init i18n com heyui
Vue.use(HeyUI, { i18n });

// vue file
i18n.locale = 'pt_BR';

moment.locale('pt-br');

export const bus = new Vue();

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
